module.exports = __webpack_public_path__ + "img/低功耗机.6836a026.jpg";